export interface IInitiatorDetails {
  name: string;
  userName: string;
  email: string;
  authorityName: string;
  authorityCountry: string;
  originatorName?: string;
  originatorUserName?: string;
}

export function initInitiatorDetails(): IInitiatorDetails {
  return {
    name: '',
    userName: '',
    email: '',
    authorityName: '',
    authorityCountry: '',
  };
}
